export { default } from './withBrowserInfo';
export * from './withBrowserInfo';
